// eslint-disable-next-line no-unused-vars
import React, {useState} from 'react'; 
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
	textboxOuter: {
	    fontFamily: "AIGFutura_Book",
	    fontWeight: "bold",
	},
	innerBorder: {
	    flex: "1 1 auto",
	    border: "solid 2px #d1d0ce",
	    flexGrow: 1,
	    boxSizing: "border-box",
	    flexBasis: "auto",
	    flexShrink: 1,
	    backgroundColor: "white",
	},
	innerBorderWithFocus: {
		border: "solid 1px #00a4e4",
        boxShadow: "0 0 4px #00a4e4",
        boxSizing: "border-box",
	},
	textboxInner: {
	    width: "100%",
	    height: "2.4em",
	    border: "none",
	    display: "flex",
	    padding: 0,
	    flexWrap: "wrap",
	    fontSize: "1.25em",
	    alignItems: "center",
	    fontFamily: "AIGFutura_Book",
	    flexDirection: "row",
	    boxAlign: "center",
	    boxOrient: "horizontal",
	    boxDirection: "normal",
    },
	textboxInput: {
	    flex: "1 0 100%",
	    width: "100%",
	    color: "#00A4E4",
	    cursor: "text",
	    margin: 0,
	    border: "none",
	    display: "inline-block",
	    fontSize: "1em",
	    flexGrow: 1,
	    flexBasis: "100%",
	    textAlign: "center",
	    paddingTop: 1,
	    textIndent: 0,
	    textShadow: "none",
	    lineHeight: 1.3,
	    fontFamily: "AIGFutura_Book",
	    fontWeight: "bold",
	    flexShrink: 0,
	    paddingLeft: 0,
	    wordSpacing: "normal",
	    writingMode: "horizontal-tb",
	    paddingRight: 0,
	    outlineWidth: 0,
	    paddingBottom: 1,
	    letterSpacing: "normal",
	    textTransform: "none",
	    textRendering: "auto",
	    backgroundColor: "white",
	    boxFlex: 1,
	    appearance: "textfield",
	    rtlOrdering: "logical",
	    boxXirection: "normal",
	},
	errorMsgBox: {
	    minHeight: "1rem",
	    fontFamily: "AIGFutura_Book",
	},
	errorMsgLabel: {
	    color: "red",
	    cursor: "default",
	    margin: 0,
	    padding: 0,
	    display: "block",
	    fontSize: "1em",
	    fontWeight: "bold",
	    verticalAlign: "top",
	},
});

interface PassInProperty{
	classes: object,
	name: string,
	id: string,
	maxLength: number,
	minLength: number,
	max: number,
	min: number,
	placeholder: string,
	value: string,
	textAlign: string,
	errorMessage: string,
	onChangeEvent: any,
	isPassword: boolean
}	

@withStyles(styles)
class TextInputField extends React.Component<PassInProperty> {
	
	constructor(props){
		super(props);
		this.state = {
			focus: false
		};
	}	
	
  	handleInputFocus = () => {
  		this.setState({
			focus: true
		})
  	};

  	handleInputBlur = () => {
  		this.setState({
			focus: false
		})
  	};	
	
	render(){
		const { 
			classes,
			name,
			id, 
			maxLength, 
			minLength, 
			max,
			min,
			placeholder, 
			value,
			textAlign,
			errorMessage,
			onChangeEvent,
			onKeyDownEvent,
			isPassword,
			//... may add other params if needed
		} = this.props;

		
		//const [focus, setFocus] = useState(false);
		  
		return (
			<div>
			  <div className={`row no-margin ${classes.textboxOuter}`}>
				  <div className={`${classes.innerBorder}` + (this.state.focus ? ` ${classes.innerBorderWithFocus}` : ``)}>
					  <div className={`row no-margin`}>
						  <div className={`col-xs`}>
							  <div className={`row between-xs middle-xs no-margin`}>
								  <div className={`col-xs col-sm`}>
									  <div className={classes.textboxInner}>
										  <input
											  className={classes.textboxInput} 
											  type={isPassword ? "password" : "text"}
											  name={name}
											  id={id} 
											  maxLength={maxLength} 
											  minLength={minLength} 
											  max={max} 
											  min={min} 
											  placeholder={placeholder}  
											  defaultValue={value} 
											  style={{ textAlign: textAlign }}
											  onFocus={this.handleInputFocus}
											  onBlur={this.handleInputBlur}
											  onChange={event => onChangeEvent(event)} 
											  onKeyDown={event => {
												if(typeof onKeyDownEvent === "function") onKeyDownEvent(event)
											  }}
										  />
									  </div>
								  </div>
							  </div>
						  </div>
					  </div>
				  </div>
			  </div>
			  <div className={classes.errorMsgBox}>
				  <label className={classes.errorMsgLabel}>
					{errorMessage}
				  </label>
			  </div>
		  </div>
		);
  	}
}

export default TextInputField;